module.exports = __webpack_public_path__ + "static/image/history/pc/202010_2.ver2_0_2.jpg?c918fda0";